import mitt, { Emitter } from "mitt"
import eventHandlers from "@/events/global-event-handlers"
import globalEvents from "@/events/global-events"

const eventBus: Emitter<Record<string, any>> = mitt()

eventBus.on(globalEvents.LOG_IN, eventHandlers.handleLogInEvent)
eventBus.on(globalEvents.LOG_OUT, eventHandlers.handleLogOutEvent)

export default eventBus
